// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}", ""]);
// Exports
module.exports = exports;
